import HistoryPromotionChallengePage from './HistoryPromotionChallengePage'
import { withHistoryPromotionChallengePage } from './withHistoryPromotionChallengePage'

const ConnectedHistoryPromotionChallengePage =
  withHistoryPromotionChallengePage(HistoryPromotionChallengePage)

export { ConnectedHistoryPromotionChallengePage as HistoryPromotionChallengePage }
